import PropTypes from "prop-types";

import styled from "styled-components/macro";

const Container = styled("div")`
  border-radius: 50%;
  overflow: clip;
  display: inline-block;
  line-height: 0px;
`;

const sizeToPx = ({ $size }) => {
  switch ($size) {
    case "lg":
      return "80px";
    case "sm":
      return "20px";
    case "md":
    default:
      return "28px";
  }
};

const Img = styled("img")`
  width: ${sizeToPx};
`;

/**
 * Takes in a URL and displays it in a circle.
 * @param {object} param0
 * @param {string} param0.url
 * @param {"sm"|"md"|"lg"} param0.size
 * @param {string} param0.alt
 * @returns
 */
const FnrCircleImg = ({ url, size = "md", alt = "" }) => (
  <Container>
    <Img src={url} alt={alt} $size={size} />
  </Container>
);

FnrCircleImg.propTypes = {
  /** The URL to the image to be displayed */
  url: PropTypes.string,
  /** How big do you want it? */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /** Text to display instead when bad things happen */
  alt: PropTypes.string,
};

export default FnrCircleImg;
